import Action from '../Action'
import './styles/ModalCisDocs.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import Search from '../generales/Search';
import SelectorAdmin from '../SelectorAdmin'
import InputForm from "../generales/InputForm";
import ModalCreateDocs from './ModalCreateDocs';
import Modal from 'react-modal';
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "95%",
    padding: "20px",
  },
};
const ModalCisDocs =({server,handleShowPopup,closeCisAfectaModal,cisSelected})=>{
  const [dataCisDocs,setdataCisDocs]=useState({data:[],loading:true,error:null})
  const [dataCis,setDataCis]=useState({data:[],loading:true,error:null})
  const [cisRelation,setCisRelation]=useState(0)
  const [relationResponse,setRelationResponse]=useState([])
  const [responseDetail,setResponseDetail]=useState({text:'',value:true})
  const [files,setFiles]=useState([])
  const [loading,setLoading]=useState(false)
  const [docMode,setDocMode]=useState(true)
  const [dataUrl,setDataUrl]=useState('')
  const [nameUrl,setNameUrl]=useState('')
  const [urlValid,setUrlValid]=useState(false)
  const [btnDisables,setBtnDisabled]=useState(false)
  const dataClasifications=useFetch('cassia/cis_v2/document_classifications','','','GET',server)
  const [hostsModalOpen, setHostsModalOpen] =useState(false);
  function openHostsModal() {
  //    setCisSelectedAux(elemento);
      setHostsModalOpen(true);
    }

  function closHostsModal() {
    
    setHostsModalOpen(false);
  }
  useEffect(()=>{
      buscar_cis_docss()
      // buscar_cis()
    },[])
  const buscar_cis_docss=()=>{
      
      
      // setLoadingCis(true)
      setdataCisDocs({data:dataCisDocs.data,loading:true,error:dataCisDocs.error})
        const fetchDataPost = async () => {
          
       try {
         const response = await fetch(server.url+'/api/v1/cassia/cis_v2/'+cisSelected.id+'/documents/', {
           // const response = await fetch(server.url+'/api/v1/cassia/ci_elements/docs/'+cisSelected.element_id, {    
         method: 'GET',  
             headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
             },
           });
         if (response.ok) {
           const data1 = await response.json();
           setdataCisDocs({data:data1.data,loading:false,error:dataCisDocs.error})
           // setCreateCisModalOpen(true)
         } else {
           const data1 = await response.json();
           throw new Error('Error en la solicitud');
         }
       } catch (error) {
            console.error(error);
          }
        };
    
        fetchDataPost();
      
  }
  const buscar_cis=()=>{
      
      
      setDataCis({data:dataCis.data,loading:true,error:null})
        const fetchDataPost = async () => {
          
       try {
         const response = await fetch(server.url+'/api/v1/cassia/ci_elements/', {
             method: 'GET',  
             headers: {
               'Content-Type': 'application/json',
               'accept': 'application/json',
               'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
             },
           });
         if (response.ok) {
           const data1 = await response.json();
           setDataCis({data:data1.data,loading:false,error:null})
           // setCreateCisModalOpen(true)
         } else {
           const data1 = await response.json();
           throw new Error('Error en la solicitud');
         }
       } catch (error) {
            console.error(error);
          }
        };
    
        fetchDataPost();
      
  }
  const handledeleteDocClick=(elemento)=>{
    setLoading(true)

    const fetchDataPost = async () => {
      try {
        const response = await fetch(server.url+'/api/v1/cassia/cis_v2/'+elemento.ci_id+'/documents/'+elemento.id, {
       
          method: 'DELETE',  
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        });
        if (response.ok) {
          const data1 = await response.json();
          setLoading(false)
          setResponseDetail({text:data1.message,value:true})
          handleShowPopup('Completado','Archivo eliminado correctamente','', true)
          const timer = setTimeout(() => {
              setResponseDetail({text:'',value:true})
            }, 2000);
          buscar_cis_docss()
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
           
           console.error(error);
         }
    };

    fetchDataPost();
  }
  const [doc_id ,setDocid]=useState(0)
  const [loadingDownload,setLoadingDownload]=useState(false)
  const handledownloadDocClick=(elemento)=>{
    setDocid(elemento.id)
    setLoadingDownload(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(server.url+'/api/v1/cassia/cis_v2/'+elemento.ci_id+'/documents/'+elemento.id+'/download', {
       
          method: 'GET',  
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        });
        if (response.ok) {
            try {
              const response_data = await response.blob();

              // Crear un enlace para descargar el archivo
              const url = window.URL.createObjectURL(response_data);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download',elemento.name); // Cambia el nombre y la extensión del archivo
              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);
              setLoadingDownload(false)
              handleShowPopup('Completado','Archivo descargado correctamente','', true)
            } catch (error) {
                console.error('Error al descargar el archivo', error);
              }
          
        //   setResponseDetail({text:data1.message,value:true})
        //   const timer = setTimeout(() => {
        //       setResponseDetail({text:'',value:true})
        //     }, 2000);
            
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
           
           console.error(error);
         }
    };

    fetchDataPost();
  }


  const handleFileChange = (event) => {
    const nombreArchivo = event.target.value.split('\\').pop();
    document.getElementById('nombre-archivo').textContent =  (nombreArchivo.length>40)?nombreArchivo.slice(40)+'...':nombreArchivo;

    const file = event.target.files[0];
    setFiles(file)
  }
  const addFile=()=>{
      setLoading(true)
      uploadFile(files);  
  }
  const uploadFile = (file) => {
      const formData = new FormData();
      // console.log(file.name)
      formData.append('file', file, file.name);
      formData.append('name', file.name);
      formData.append('description', 'Documento cargado desde la app');
      fetch(server.url+'/api/v1/cassia/cis_v2/'+cisSelected.id+'/documents/upload', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`, // Reemplaza tu_token con tu token de autorización
        },
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        // document.getElementById('nombre-archivo').textContent =''
        setFiles([])
        setLoading(false)
        buscar_cis_docss()
        setResponseDetail({text:data.message,value:true})
        handleShowPopup('Completado','Archivo agregado correctamente','', true)
        const timer = setTimeout(() => {
            setResponseDetail({text:'',value:true})
          }, 2000);
      })
      .catch(error => {
        console.error('Error al enviar el archivo:', error);
      });
    }
  const addUrl=()=>{
    setLoading(true)
    uploadUrl();  
}
  const uploadUrl = () => {
      const formData = new FormData();
      formData.append('location', dataUrl);
      formData.append('name', nameUrl);
      formData.append('description', 'Documento cargado desde la app');
      formData.append('type', "URL");
      const data={
          location: dataUrl,
          name: nameUrl,
          description: 'Documento cargado desde la app',
          type: "URL"
      }
      // formData.append('files', file, file.name);
      fetch(server.url+'/api/v1/cassia/cis_v2/'+cisSelected.id+'/documents/url', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`, // Reemplaza tu_token con tu token de autorización
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then(data => {
        // document.getElementById('nombre-archivo').textContent =''
        setFiles([])
        setLoading(false)
        buscar_cis_docss()
        setDataUrl("")
        setBtnDisabled(true)
        setNameUrl("")
        setResponseDetail({text:data.message,value:true})
        handleShowPopup('Completado','URL agregado correctamente','', true)
        const timer = setTimeout(() => {
            setResponseDetail({text:'',value:true})
          }, 2000);
      })
      .catch(error => {
        console.error('Error al enviar el archivo:', error);
      });
    }
  const handleChange=(e)=>{
    const {name,value}=e.target
    if(name=='URL'){
      setDataUrl(value)
    }else{
      setNameUrl(value)
    }

    // setUrlValid(validateurl(value))
    setUrlValid(true)
  }
  useEffect(()=>{
      if(dataUrl=="" || nameUrl==""){
        setBtnDisabled(true)
      }else{
        setBtnDisabled(false)
      }
  },[dataUrl,nameUrl])
  const validateurl= (url) => {
    const ipRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/\S*)?$/;
    let result = ipRegex.test(url);

    return result;
  };

  const changeOption=(option,index)=>{
  
    //  setCisData((prevState)=>{
    //         return {
    //             ...prevState,
    //             [option.filter]:option.label
    //         }
            
    //     })
        
}
  return(
      <>
      <div className="modal-user-content">
           <div className='card-users modal-verificate' style={{background:'var(--white-color)'}}>
               {/* <div className='head-card-cis'>
                   <div className='title-head-card-users' style={{display:'flex',justifyContent:'space-around',alignItems: 'center'}}>
                      <div>Documentos de : &nbsp;</div><div>  {'   '+cisSelected.folio}</div>
                   </div>
               </div> */}
               <div className='content-card-users' >
               <div className='body_info_cis_docs'>
       <div className='content-cis_docs' style={{border: 'px solid #607582',boxShadow:'unset'}}>
               
               <div className='cont-cis-search' style={{background:'transparent '}}>
                 <div className='cont-docs-menu'>
                   {/* <div className='compact-switch-docs-menu'>
                   <div class="container-switch-docs-menu">
       <input type="checkbox" name="check" onClick={()=>setDocMode(!docMode)} defaultChecked={true} id="check" hidden="" style={{position: "relative",left: "15%"}}/>
       <label htmlFor="check" class="toggle" style={{width:'15%'}}>
           <div class="toggle__circle"></div>
       </label>
       <div class="toggle-text">
           <span style={{height:'50%',display:'flex',alignItems:'center'}}>PDF</span>
           <span style={{height:'50%',display:'flex',alignItems:'center'}}>URL</span>
       </div>
   </div>
                   </div> */}
                   <div className='form-docs-cis'>
                     {
                       (docMode)?<>
                       {/* <div className='cont-search-docs hiddenPDF'>
                           <div className="custom-file-input">
                               <input type="file" id="archivo" className="input-file"  onChange={handleFileChange} />
                               <label style={{position:'relative',left:'-20px'}} htmlFor="archivo" className="btn">Examinar</label>
                               <span id="nombre-archivo"></span>
                           </div>
       
                       </div> */}
                       {/* <div className="row-form-modal" style={{height:'100%'}}>
                   <div className="colum-form-modal" style={{width:'80%'}}>
                       {(dataClasifications.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                       <InputForm  optionDefault={0} type='selector' endpoint='field_option'msgError={'El Solicitante y Autorizador no pueden ser iguales'}  error={false} changeOption={changeOption}  attr={'classification_id'} titulo={'Clasificación'} loading={dataClasifications.loading} data={dataClasifications.data.data} text={''} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                       }
                       </div>
                 
                 </div> */}
                       <div className='cont-search-buttons hiddenPDF' style={{left:'80%'}}>
                       <Action disabled={false} origen='Cielo' titulo='Agregar' action={openHostsModal}  />
                       </div>
                       
                     </>:
                     <>
                     <div className='cont-inpt-url-doc'>
                     <label className='lbl-doc-url ' style={{color:'#003757'}}>{'URL  '}</label>
                                       <input className='inp-doc-url' required name="URL"  placeholder='URL' type="text" value={dataUrl}
                                   onChange={handleChange}  />   
                     </div>
                     <div className='cont-inpt-url-doc'>
                     <label className='lbl-doc-url '>Nombre</label>
                                       <input className='inp-doc-url' required name="Nombre"  placeholder='Nombre' type="text" value={nameUrl}
                                   onChange={handleChange}  />
                     </div>
                     <div className='cont-search-buttons hiddenPDF'>
                     <Action disabled={btnDisables} origen='Cielo' titulo='Agregar' action={addUrl}  />
                     </div>
                   </>
                     }
                 
                   </div>
                 
                 </div>

             


               </div>
               <div className='cont-cis-table-docs'>
                   <div className='content-card-cis-docs ' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                   
                   {
                       (dataCisDocs.loading || loading)?<div style={{display:'flex',position:'relative',width:'100%',height:'100%',justifyContent:'center',alignItems:'center'}}><LoadSimple></LoadSimple></div>:
                       
                       dataCisDocs.data.map((elemento, indice) => (
                       <div className='cont-elemen-docs' >
                           <div className='elemen-docs'>
                              <div className='con-elemen-docs-info'>
                               {elemento.name.slice(0,40)+" "+(elemento.name.length>40?'...':'')}
                               </div>
                               <div className='con-elemen-docs-img'>
                                   <div className='cont-img-field-acciones' >
                                     {
                                       (elemento.type!='FILE')?
                                       <a  target="_blank" href={elemento.location}>
                                         <img style={{width:'unset'}}className='img-field-acciones img-docs' src={'/iconos/web.png'} title='IR'name='IR' ci_id={elemento.ci_id}  />
                                       </a>:
                                       
                                         (loadingDownload && doc_id==elemento.id)?
                                         <div className='cont-load-download-doc'>
                                           <LoadSimple></LoadSimple>
                                         </div>:
                                       <img style={{width:'unset'}} className='img-field-acciones img-docs' src={'/iconos/pdf.png'} title='Descargar'name='Descargar' ci_id={elemento.ci_id} onClick={(e)=> {e.stopPropagation(); handledownloadDocClick(elemento)}} />

                                       
                                     }
                                       
                                   </div>
                               </div>
                               <div className='con-elemen-docs-img'>
                                   <div className='cont-img-field-acciones' >
                                       <img style={{width:'unset'}} className='img-field-acciones img-docs' src='/iconos/delete.png' title='Eliminar'name='Eliminar' ci_id={elemento.ci_id} onClick={(e)=> {e.stopPropagation(); handledeleteDocClick(elemento)}} />
                                   </div>
                               </div>
                           </div>
                       </div>
                       ))

                   }
                                   
                   </div>
               </div>
           </div>
       </div>
                                  
               </div>
               <div className='msgErrorDocs' style={{color:(responseDetail.value)?'gree':'red'}}>
                          {responseDetail.text}
                       </div>
               </div>
       </div>
<Modal
       isOpen={hostsModalOpen}
       // isOpen={true}
       // onAfterOpen={afterOpenExeption}
       onRequestClose={closHostsModal}
       style={hostListModalSyncStyles}
       contentLabel="Example Modal2"
       // shouldCloseOnOverlayClick={false}
       >
         <ModalCreateDocs handleShowPopup={handleShowPopup} closeCisAfecta={closeCisAfectaModal} cisSelected={cisSelected} buscar_cis_docss={buscar_cis_docss} dataClasifications={dataClasifications} server={server}    closHostsModal={closHostsModal}></ModalCreateDocs>
   </Modal>

      </>
   )
}

export default ModalCisDocs